import { defineArrayMember, defineField, defineType } from "sanity";

export const categoryImages = defineType({
  name: "categoryImages",
  title: "Category & Subcategory Images",
  type: "document",
  description:
    "Upload custom thumbnail images for categories, subcategories, and stone types. These override the default product images shown on browse pages.",
  fields: [
    defineField({
      name: "title",
      title: "Title",
      type: "string",
      hidden: true
    }),
    defineField({
      name: "images",
      title: "Thumbnail Images",
      type: "array",
      description:
        "Add an entry for each category, subcategory, or stone type you want to customize. Use the exact label shown on the site (e.g. 'Rings', 'Solitaire', 'Diamond').",
      of: [
        defineArrayMember({
          type: "object",
          fields: [
            defineField({
              name: "label",
              title: "Category / Subcategory / Stone Name",
              type: "string",
              description:
                "The exact name as it appears on the site. Examples: 'Necklaces', 'Tennis', 'Diamond', 'Semi Precious'.",
              validation: (Rule) =>
                Rule.required().error("Enter the category or subcategory name.")
            }),
            defineField({
              name: "image",
              title: "Thumbnail Image",
              type: "image",
              description:
                "Square images work best. This will appear as a circular thumbnail on browse pages.",
              options: { hotspot: true },
              validation: (Rule) =>
                Rule.required().error("Upload a thumbnail image."),
              fields: [
                defineField({
                  name: "alt",
                  title: "Alt text",
                  type: "string",
                  description: "Describe the image for screen readers."
                })
              ]
            })
          ],
          preview: {
            select: {
              title: "label",
              media: "image"
            }
          }
        })
      ]
    })
  ],
  initialValue: {
    title: "Category & Subcategory Images"
  },
  preview: {
    prepare: () => ({
      title: "Category & Subcategory Images"
    })
  }
});
